(function () {
  var fromParam = (new URLSearchParams(window.location.search)).get('from') === 'kit-personalizado';
  var swatchTs = null;
  try { swatchTs = sessionStorage.getItem('kitSwatchClick'); } catch (e) {}
  var fromSwatch = swatchTs && (Date.now() - parseInt(swatchTs, 10)) < 5000;
  if (fromSwatch) { try { sessionStorage.removeItem('kitSwatchClick'); } catch (e) {} }
  var fromKit = fromParam || fromSwatch;
  if (!fromKit) return;

  function watchSwatches() {
    function tagSwatches() {
      document.querySelectorAll('[class*="rio-swatch"]').forEach(function (el) {
        if (el.dataset.kitWatched) return;
        el.dataset.kitWatched = '1';
        el.addEventListener('click', function () {
          try { sessionStorage.setItem('kitSwatchClick', Date.now().toString()); } catch (e) {}
        });
      });
    }
    if (document.body) tagSwatches();
    var obs = new MutationObserver(tagSwatches);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { obs.observe(document.body, { childList: true, subtree: true }); tagSwatches(); });
    } else {
      obs.observe(document.body, { childList: true, subtree: true }); tagSwatches();
    }
  }
  watchSwatches();

  var _replaceState = history.replaceState.bind(history);
  history.replaceState = function (state, title, url) {
    if (url && typeof url === 'string' && url.indexOf('from=kit-personalizado') === -1) {
      url = url + (url.indexOf('?') !== -1 ? '&' : '?') + 'from=kit-personalizado';
    }
    return _replaceState(state, title, url);
  };

  function tagColorLinks() {
    document.querySelectorAll('a[href*="/products/"]').forEach(function (link) {
      if (!link.href || link.href.indexOf('from=kit-personalizado') !== -1) return;
      try {
        var url = new URL(link.href, window.location.origin);
        if (url.pathname.indexOf('/products/') === -1) return;
        url.searchParams.set('from', 'kit-personalizado');
        link.href = url.toString();
      } catch (e) {}
    });
  }

  function formatMoney(cents) {
    return 'R$ ' + (cents / 100).toFixed(2).replace('.', ',');
  }

  function openDrawer(cart) {
    var drawer = document.querySelector('.halo-cart-sidebar');
    if (!drawer) {
      document.body.classList.add('cart-sidebar-show');
      return;
    }

    var itemsHtml = '';
    if (cart.items && cart.items.length > 0) {
      cart.items.forEach(function (item) {
        var variantInfo = item.variant_title && item.variant_title !== 'Default Title'
          ? '<span class="cart-item__variant">' + item.variant_title + '</span>'
          : '';
        itemsHtml += [
          '<div class="cart-item" style="display:flex;gap:12px;padding:12px 0;border-bottom:1px solid #eee;">',
            '<img src="' + item.image + '" alt="' + item.title + '" style="width:72px;height:72px;object-fit:cover;border-radius:4px;">',
            '<div style="flex:1;">',
              '<p style="margin:0 0 4px;font-size:14px;font-weight:600;">' + item.product_title + '</p>',
              variantInfo,
              '<p style="margin:4px 0;font-size:13px;color:#666;">Qtd: ' + item.quantity + '</p>',
              '<p style="margin:0;font-size:14px;font-weight:600;">' + formatMoney(item.final_line_price) + '</p>',
            '</div>',
          '</div>'
        ].join('');
      });
    } else {
      itemsHtml = '<p style="text-align:center;color:#888;padding:24px 0;">Seu carrinho está vazio</p>';
    }

    var totalHtml = cart.items && cart.items.length > 0
      ? '<div style="padding:16px 0;border-top:2px solid #eee;margin-top:8px;">' +
          '<div style="display:flex;justify-content:space-between;font-weight:700;font-size:16px;margin-bottom:12px;">' +
            '<span>Total</span><span>' + formatMoney(cart.total_price) + '</span>' +
          '</div>' +
          '<a href="/cart" style="display:block;width:100%;margin-bottom:8px;padding:12px;background:#fff;color:#000;border:1px solid #000;border-radius:4px;font-size:14px;font-weight:600;cursor:pointer;text-align:center;text-decoration:none;">Ver carrinho completo</a>' +
          '<button onclick="if(typeof window.endShopping===\'function\'){window.endShopping(event)}else{window.location.href=\'/cart\'}" ' +
            'style="width:100%;margin-top:12px;padding:14px;background:#000;color:#fff;border:none;border-radius:4px;font-size:15px;font-weight:600;cursor:pointer;">' +
            '🛒 Finalizar compra' +
          '</button>' +
        '</div>'
      : '';

    drawer.innerHTML = [
      '<div style="display:flex;align-items:center;justify-content:space-between;padding:16px;border-bottom:1px solid #eee;">',
        '<h3 style="margin:0;font-size:18px;">Carrinho (' + cart.item_count + ')</h3>',
        '<button data-close-cart-sidebar type="button" style="background:none;border:none;font-size:24px;cursor:pointer;line-height:1;" aria-label="Fechar">✕</button>',
      '</div>',
      '<div style="padding:0 16px;overflow-y:auto;max-height:calc(100vh - 200px);">',
        itemsHtml,
      '</div>',
      '<div style="padding:0 16px;">',
        totalHtml,
      '</div>'
    ].join('');

    // Botão de fechar
    var closeBtn = drawer.querySelector('[data-close-cart-sidebar]');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        document.body.classList.remove('cart-sidebar-show');
      });
    }

    document.body.classList.add('cart-sidebar-show');
  }

  function showModal(cart) {
    if (document.querySelector('.kit-modal')) return;

    openDrawer(cart);

    var overlay = document.createElement('div');
    overlay.className = 'kit-modal-overlay';
    document.body.appendChild(overlay);

    var modal = document.createElement('div');
    modal.className = 'kit-modal';
    modal.innerHTML = [
      '<button class="kit-modal__close" aria-label="Fechar">✕</button>',
      '<p class="kit-modal__title">✅ Adicionado ao carrinho!</p>',
      '<p class="kit-modal__subtitle">O que deseja fazer agora?</p>',
      '<a href="/collections/kit-personalizado" class="kit-modal__btn kit-modal__btn--primary">🎁 Continuar montando o kit</a>',
      '<button class="kit-modal__btn kit-modal__btn--secondary" id="kit-modal-checkout">🛒 Finalizar compra</button>'
    ].join('');
    document.body.appendChild(modal);

    function closeModal() { overlay.remove(); modal.remove(); }
    overlay.addEventListener('click', closeModal);
    modal.querySelector('.kit-modal__close').addEventListener('click', closeModal);

    modal.querySelector('#kit-modal-checkout').addEventListener('click', function (e) {
      if (typeof window.endShopping === 'function') { window.endShopping(e); }
      else { window.location.href = '/cart'; }
    });
  }

  function interceptAddToCart() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('button[type="submit"], input[type="submit"]');
      if (!btn) return;
      var form = btn.closest('form[action*="/cart/add"]');
      if (!form) return;

      e.preventDefault();
      e.stopImmediatePropagation();

      var formData = new FormData(form);
      var variantId = formData.get('id');
      var quantity = formData.get('quantity') || 1;
      if (!variantId) return;

      btn.disabled = true;
      var originalText = btn.textContent;
      btn.textContent = 'Adicionando...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId, 10), quantity: parseInt(quantity, 10) })
      })
      .then(function(r) { return r.json(); })
      .then(function(item) {
        if (item.status) {
          btn.textContent = item.description || 'Erro — tente novamente';
          btn.disabled = false;
          return;
        }
        btn.textContent = '✓ Adicionado!';
        fetch('/cart.js', { credentials: 'same-origin' })
          .then(function(r) { return r.json(); })
          .then(function(cart) {
            document.querySelectorAll('.cart-count-bubble span, .cartCount, [data-cart-count]').forEach(function(el) {
              el.textContent = cart.item_count;
            });
            showModal(cart);
          });
        setTimeout(function() { btn.textContent = originalText; btn.disabled = false; }, 2000);
      })
      .catch(function() { btn.textContent = originalText; btn.disabled = false; });
    }, true);
  }

  function init() {
    tagColorLinks();
    interceptAddToCart();
    new MutationObserver(function() { tagColorLinks(); }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
